import { arrayOf, number, shape, string } from 'prop-types'

export const trackingUrls = shape({
  impressionUrl: string,
  clickUrl: string,
  events: arrayOf(shape({ id: number, url: string })),
})

export const metadataContent = shape({
  trackingUrls,
  creativeId: number,
  flightId: number,
  campaignId: number,
  position: number,
})
export const adServerMetadata = shape({
  pzn: metadataContent,
})

export const targetingContext = {
  expa: string,
  tenant: string,
  brandName: string,
  categoryId: string,
  secondLevelCategories: arrayOf(string),
  pzn: string,
  manufacturerCode: string,
  searchTerm: string,
}
